import './PublicReportPage.scss';

import { useGetPublicCompanySettingsQuery } from 'common/queries';
import { LoadingIndicator } from 'components';
import React from 'react';
import { useParams } from 'react-router-dom';

import PublicReportOld from './PublicReportOld';
import PublicReportPdf from './PublicReportPdf';
import { useGetPublicReportQuery } from './queries';

type RouteParams =
  | 'tenantCode'
  | 'customerId'
  | 'orderCustomFormId'
  | 'reportId'
  | 'serviceObjectId';

const PublicReportPage: React.FC = (): React.ReactElement => {
  const params = useParams<RouteParams>();

  const reportQuery = useGetPublicReportQuery(
    params.tenantCode || '',
    params.customerId || '',
    params.orderCustomFormId || '',
    params.reportId || '',
    params.serviceObjectId
  );

  const publicCompanySettingsQuery = useGetPublicCompanySettingsQuery(params.tenantCode);

  const isLoading = publicCompanySettingsQuery.isLoading || reportQuery.isLoading;

  if (isLoading) {
    return <LoadingIndicator />;
  }

  const lang =
    reportQuery.data?.reportDocument?.language ||
    publicCompanySettingsQuery.data?.languageId.toLocaleLowerCase();

  return reportQuery.data?.reportDocument ? (
    <PublicReportPdf document={reportQuery.data.reportDocument} lang={lang} />
  ) : (
    <PublicReportOld lang={lang} />
  );
};

export default PublicReportPage;
